import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Stack, TextField, Typography, Alert, Link } from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { forgotPassword } from '../../services/authService';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);

    try {
      await forgotPassword(email);
      localStorage.setItem('resetEmail', email);
      navigate('/verify-otp');
    } catch (err: any) {
      setError(err.response?.data?.msg || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
        background:
          'radial-gradient(circle at top, rgba(90, 75, 252, 0.12), transparent 40%), radial-gradient(circle at bottom, rgba(0, 184, 148, 0.16), transparent 45%), #f4f6fb',
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 3,
          boxShadow: '0 36px 60px rgba(15, 23, 42, 0.16)',
        }}
      >
        <CardContent sx={{ p: { xs: 4, md: 5 } }}>
          <Stack spacing={4}>
            <Box>
              <Typography variant="h5" fontWeight={700}>
                Forgot password?
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Enter the email tied to your ZapTick AI account and we’ll send a one-time code to reset your password.
              </Typography>
            </Box>

            <Stack component="form" spacing={3} onSubmit={handleSubmit}>
              {error && <Alert severity="error">{error}</Alert>}

              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                fullWidth
                autoComplete="email"
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={loading}
              >
                {loading ? 'Sending…' : 'Send verification code'}
              </Button>
            </Stack>

            <Typography variant="body2" color="text.secondary" align="center">
              Remember your password?{' '}
              <Link component={RouterLink} to="/login" underline="hover">
                Back to login
              </Link>
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPasswordPage;
